import { OrganizationInfo } from './OrganizationInfo.main';

export { OrganizationInfo };
